type LoadingPricingCardProps = {
  className?: string;
};

export default function LoadingPricingCard({
  className,
}: LoadingPricingCardProps) {
  return (
    <div data-testid="loadingpricingcard" className={className}>
      <div className="bg-inherit h-[545px] pt-6">
        <div className="animate-pulse">
          <div className="flex space-x-10">
            <div className="flex-1">
              <div className="w-full h-3 mb-4 bg-border-base rounded-xl" />
              <div className="bg-border-base h-3 w-[50%] rounded-xl mb-4" />
              <div className="bg-border-base h-3 w-[55%] rounded-xl mb-4" />
              <div className="bg-border-base h-3 w-[60%] rounded-xl mb-4" />
              <div className="bg-border-base h-3 w-[65%] rounded-xl mb-4" />
              <div className="bg-border-base h-3 w-[70%] rounded-xl mb-4" />
              <div className="bg-border-base h-3 w-[75%] rounded-xl mb-4" />
              <div className="bg-border-base h-3 w-[80%] rounded-xl mb-4" />
              <div className="bg-border-base h-3 w-[85%] rounded-xl mb-4" />
              <div className="bg-border-base h-3 w-[90%] rounded-xl" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
